import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";
import Home from "./pages/Home";
import Result from "./pages/Result";
import FAQ from "./pages/FAQ";
import Support from "./pages/Support";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Cancel from "./pages/Cancel";
import LoadingDemo from "./pages/LoadingDemo";
import AdminDashboard from "./pages/admin/AdminDashboard";
import { Toaster } from "./components/ui/sonner";

// SEO Pages
import AirlinesHub from "./pages/seo/AirlinesHub";
import AirlineDetail from "./pages/seo/AirlineDetail";
import DestinationsHub from "./pages/seo/DestinationsHub";
import DestinationDetail from "./pages/seo/DestinationDetail";
import BreedsHub from "./pages/seo/BreedsHub";
import BreedDetail from "./pages/seo/BreedDetail";
import GuidesHub from "./pages/seo/GuidesHub";
import GuideDetail from "./pages/seo/GuideDetail";

// B2B Page
import B2BPage from "./pages/B2BPage";
import ProSuccessPage from "./pages/ProSuccessPage";
import NotFound from "./pages/NotFound";
import CookieConsent from "./components/CookieConsent";
import HomeFr from "./pages/HomeFr";

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-gradient-to-b from-slate-50 to-white overflow-x-hidden">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/result" element={<Result />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/support" element={<Support />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cancel" element={<Cancel />} />
            <Route path="/loading-demo" element={<LoadingDemo />} />
            <Route path="/admin" element={<AdminDashboard />} />
            
            {/* SEO Pages */}
            <Route path="/airlines" element={<AirlinesHub />} />
            <Route path="/airlines/:slug" element={<AirlineDetail />} />
            <Route path="/destinations" element={<DestinationsHub />} />
            <Route path="/destinations/:slug" element={<DestinationDetail />} />
            <Route path="/breeds" element={<BreedsHub />} />
            <Route path="/breeds/:slug" element={<BreedDetail />} />
            <Route path="/guides" element={<GuidesHub />} />
            <Route path="/guides/:slug" element={<GuideDetail />} />
            
            {/* B2B Page */}
            <Route path="/business" element={<B2BPage />} />
            <Route path="/partners" element={<B2BPage />} />
            <Route path="/b2b" element={<B2BPage />} />
            <Route path="/pro" element={<B2BPage />} />
            <Route path="/pro/success" element={<ProSuccessPage />} />
            <Route path="/fr" element={<HomeFr />} />
            <Route path="/contact" element={<Navigate to="/support" replace />} />
            <Route path="/guarantee" element={<Navigate to="/terms" replace />} />
            <Route path="/about" element={<Navigate to="/" replace />} />
            <Route path="/cookies" element={<Navigate to="/privacy" replace />} />
            <Route path="/shop/*" element={<Navigate to="/" replace />} />
            <Route path="/guides/airline-pet-policies" element={<Navigate to="/airlines" replace />} />
            <Route path="/guides/flying-with-dog-requirements-2026" element={<Navigate to="/guides/iata-crate-requirements-2026" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <CookieConsent />
        </BrowserRouter>
        <Toaster position="top-center" />
      </div>
    </HelmetProvider>
  );
}

export default App;
